import React from 'react';
import PriceDisplay from './priceDisplay';

const Options = ({list}) => {
    return (
        <ul className="options-list">
            {
                list.map((item) => {
                    return (
                        <li>{item.title}</li>
                    )
                })
            }
        </ul>
    )
}

const SideBar = ({boothInfo, prices}) => {

    let optionsPrice = prices.selectedOptions.reduce((total, current) => {
        return total + current.price;
    }, 0);


    return (
        <div className="column is-one-quarter-tablet">
            {/*<div className="hero is-danger">*/}
                {/*<div className="hero-body has-text-centered has-text-white content">*/}
                    {/*<h4 className="has-text-white">Samenvatting reservering</h4>*/}
                    {/*<table className="is-fullwidth price-table">*/}
                        {/*<tbody>*/}
                        {/*<tr>*/}
                            {/*<td>Type photobooth</td>*/}
                            {/*<td>{boothInfo.name}</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                            {/*<td>Huurtijd</td>*/}
                            {/*<td>24 uur</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                            {/*<td>Brengen</td>*/}
                            {/*<td>na 09:00 uur</td>*/}
                        {/*</tr>*/}
                        {/*<tr>*/}
                            {/*<td>Halen</td>*/}
                            {/*<td>voor 09:00</td>*/}
                        {/*</tr>*/}
                        {/*</tbody>*/}
                    {/*</table>*/}
                {/*</div>*/}
            {/*</div>*/}
            <div className="hero is-primary">
                <div className="hero-body has-text-white has-text-centered content">
                    <h4 className="has-text-white">Samenvatting reservering</h4>
                    <table className="is-fullwidth price-table">
                        <tbody>
                        <tr>
                            <td>Basisprijs</td>
                            <td>
                                <PriceDisplay price={prices.basePrice} />
                            </td>
                        </tr>
                        <tr>
                            <td>
                                Opties
                                {
                                    prices.selectedOptions.length > 0 && <Options list={prices.selectedOptions} />

                                }
                            </td>
                            <td>
                                <PriceDisplay price={optionsPrice} hideAlternative={true} />
                            </td>
                        </tr>
                        <tr>
                            <td>Totaalprijs</td>
                            <td>
                                <PriceDisplay price={prices.basePrice + optionsPrice} />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                    <p className="has-text-centered">
                        <small>Bovenstaande bedragen zijn inclusief 21% b.t.w.</small>
                    </p>
                </div>
            </div>
            <div className="card">
                <div className="card-content">
                    <div className="content">
                        <p>
                            <strong>
                                WAT IS INBEGREPEN?
                            </strong>
                            <br/>
                            Als je bij ons een photobooth huurt dan is onderstaande standaard inbegrepen. Je kunt dit nog uitbreiden met opties bij de volgende stap.
                        </p>
                    </div>
                </div>
            </div>
        </div>
    )
};

export default SideBar;


// WEBPACK FOOTER //
// ./src/components/reservationForm/sidebar.js